module.exports = __webpack_public_path__ + "static/media/kudos-like-icon.788cce3f.svg";